/* eslint-disable angular/controller-name, angular/controller-as */

angular.
module("digiexam").
controller("SidebarController", function SidebarController(
	$scope,
	$location,
	$route,
	Broadcaster,
	dxSession,
	DX_URLS,
	RoleTypeEnum,
	Auth
) {
	"use strict";

	$scope.activeMenuItem = "overview";

	// Kind of hacky way to bind the current role in the dropdown :<
	$scope.$watch("dxSession.getRole()", function roleChange() {
		var roles = dxSession.getAvailableRoles();
		for (var i = 0; i < roles.length; i++) {
			if (roles[i].id === dxSession.getRole().id && roles[i].roleType === dxSession.getRole().roleType) {
				$scope.selectedRole = roles[i];
				break;
			}
		}
	});

	$scope.isFreemium = dxSession.getRole().isFreemium;

	$scope.changeRole = function changeRole(role) {
		Auth.clearCache();
		if (!role) {
			return;
		}

		dxSession.setRole(role);
		$scope.isFreemium = dxSession.getRole().isFreemium;

		if (role && role.roleType === RoleTypeEnum.ACCOUNTMANAGER) {
			if (role.organizationId !== null) {
				$location.path(DX_URLS.get("roles", {id: role.organizationId}));
				$route.reload();
			}
		} else if (role && role.roleType === RoleTypeEnum.MASTER) {
			$location.path(DX_URLS.get("masterToolsSearch"));
		} else {
			$location.path(DX_URLS.get("overview"));
			$route.reload();
		}
	};

	$scope.isChangeRoleEnabled = function isChangeRoleEnabled() {
		return dxSession.getAvailableRoles().length > 1;
	};

	$scope.isActiveMenuItem = function isActiveMenuItem(item) {
		return item === $scope.activeMenuItem;
	};

	$scope.hasAccess = function hasAccess(roleType) {
		return !!(dxSession.getRole().roleType & roleType);
	};

	$scope.$on("setActiveMenuItem", function setActiveMenuItem() {
		$scope.activeMenuItem = Broadcaster.message;
	});
});
